/**
 * Antifraud frontend API
 * Antifraud frontend API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum DeletedBaseType {
    AUTO = 'AUTO',
    DATE_BEFORE_CUTOFF = 'DATE_BEFORE_CUTOFF',
    DELETED_BY_MIA = 'DELETED_BY_MIA',
    DELETED_BY_NPCK = 'DELETED_BY_NPCK',
    DOUBLE = 'DOUBLE',
    DUPLICATE_TREND = 'DUPLICATE_TREND',
    FALSE_POSITIVE_TREND = 'FALSE_POSITIVE_TREND',
    IRRELEVANT_TREND = 'IRRELEVANT_TREND',
    MAIN_INCIDENT_EXISTS = 'MAIN_INCIDENT_EXISTS',
    MISTAKE = 'MISTAKE',
    NO_LINKED_ORGANIZATIONS = 'NO_LINKED_ORGANIZATIONS',
    OTHER = 'OTHER',
    UNIDENTIFIABLE_OPERATION = 'UNIDENTIFIABLE_OPERATION'
}

